import React from 'react';
import { Card, Row, Col, Form, Input, InputNumber, Button, message, Modal,
	Table, Tag, Tabs, Typography, Tooltip, Select, Empty, Alert, Timeline, Checkbox,
	Radio, Collapse, Spin,
} from 'antd';
import {
	InboxOutlined, PlusOutlined, CheckCircleOutlined, CloseCircleOutlined,
	ClockCircleOutlined, RedoOutlined, SendOutlined, GoldOutlined, HistoryOutlined,
	UndoOutlined, DisconnectOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import { Helmet } from 'react-helmet';
import Config from '../../Config';
import ErrorAlertModal from '../../components/ErrorAlertModal';
import { BoxVisualCard } from '../../components/BoxVisualList';

const { Text } = Typography;
const { TextArea } = Input;
const { TabPane } = Tabs;
const { Option } = Select;

const configClass = {
	title: 'Gudang Notice',
	apiUrl: {
		box: 'gudangnotice/api/box/',
		permintaan: 'gudangnotice/api/permintaan/',
		upt: 'pegawai/api/upt/',
	},
	breadCrumb: [<span><InboxOutlined /> Master</span>, 'Gudang Notice'],
};

const BOX_STATUS = {
	gudang: { color: '#e6f0fb', border: '#91b4e8', text: '#1e4d8a', label: 'Di Gudang' },
	diterima: { color: '#f9f0ff', border: '#d3adf7', text: '#531dab', label: 'Diterima (Belum Ditempatkan)' },
	dialokasikan: { color: '#fffbe6', border: '#ffe58f', text: '#ad6800', label: 'Dialokasikan' },
	aktif: { color: '#f6ffed', border: '#b7eb8f', text: '#389e0d', label: 'Aktif Dipakai' },
	habis: { color: '#fff1f0', border: '#ffa39e', text: '#cf1322', label: 'Habis Terpakai' },
};

// Urutan & ikon kategori kartu tab "Rekap Stok" - label/warna reuse BOX_STATUS
// supaya konsisten dgn Tag status yang sudah dipakai di tabel "Stok Box".
const REKAP_CATEGORIES = [
	{ status: 'gudang', icon: <InboxOutlined /> },
	{ status: 'diterima', icon: <ClockCircleOutlined /> },
	{ status: 'dialokasikan', icon: <GoldOutlined /> },
	{ status: 'aktif', icon: <CheckCircleOutlined /> },
	{ status: 'habis', icon: <DisconnectOutlined /> },
];

const PERMINTAAN_STATUS = {
	pending: { color: '#fffbe6', border: '#ffe58f', text: '#ad6800', label: 'Menunggu Persetujuan', icon: <ClockCircleOutlined /> },
	disetujui: { color: '#f6ffed', border: '#b7eb8f', text: '#389e0d', label: 'Disetujui', icon: <CheckCircleOutlined /> },
	disetujui_sebagian: { color: '#e6f0fb', border: '#91b4e8', text: '#1e4d8a', label: 'Disetujui Sebagian', icon: <CheckCircleOutlined /> },
	ditolak: { color: '#fff1f0', border: '#ffa39e', text: '#cf1322', label: 'Ditolak', icon: <CloseCircleOutlined /> },
};

const StatusTag = ({ map, value }) => {
	const s = map[value] || { color: '#f5f5f5', border: '#d9d9d9', text: '#666', label: value };
	return (
		<Tag icon={s.icon} style={{ borderRadius: 20, fontWeight: 600, fontSize: 12, background: s.color, borderColor: s.border, color: s.text }}>
			{s.label}
		</Tag>
	);
};

const config = new Config();

class DataGudangNotice extends React.Component {
	formTambahBoxRef = React.createRef();
	formAjukanRef = React.createRef();
	formApproveRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			activeTab: 'box',
			isMobile: window.innerWidth <= 768,

			loadingBox: false, listBox: [],
			boxPagination: { current: 1, pageSize: 10, total: 0 },
			filterBoxStatus: undefined,
			filterBoxKode: '',
			boxViewMode: 'table',
			loadingBoxVisual: false, listBoxVisual: [],

			// Filter Kabupaten/UPT - dipakai bareng tab "Stok Box" & "Rekap Stok".
			// Cuma ditampilkan utk role yang backend-nya benar-benar memproses
			// param ini (lihat BoxNoticeViewset.get_queryset) - staf biasa (1 UPT)
			// tidak dapat dropdown ini krn query param dari mereka diabaikan backend.
			filterKabupatenId: undefined, filterUptId: undefined,
			loadingKabupatenFilter: false, listKabupatenFilter: [],
			loadingUptFilter: false, listUptFilter: [],

			loadingRekap: false, listRekap: [],

			kandidatPanel: {},

			loadingUpt: false, listUpt: [],
			modalAlokasikan: false, loadingAlokasikan: false, alokasikanUptId: undefined,
			alokasikanTargetBox: null,
			konfirmasiPindahAktif: false,

			loadingKodeTersedia: false, kodeTersediaList: [],

			loadingPermintaan: false, listPermintaan: [],
			permintaanPagination: { current: 1, pageSize: 10, total: 0 },

			modalTambahBox: false, loadingTambahBox: false,
			cekKodeLoading: false, cekKodeInfo: null, lastSaranPrefilled: null,
			modalAjukan: false, loadingAjukan: false,

			selectedBoxRowKeys: [], lastSelectedBoxRowIndex: null,
			modalHapusBatch: false, loadingHapusBatch: false,

			modalApprove: false, modalReject: false,
			selectedPermintaan: null, loadingAction: false, catatanApproval: '',

			modalRiwayat: false, loadingRiwayat: false, riwayatList: [], riwayatBox: null,

			modalLepas: false, lepasTarget: null, loadingLepas: false,
			modalKembalikan: false, kembalikanTarget: null, loadingKembalikan: false,

			stokMenipisCount: 0, stokMenipisThreshold: 100, stokMenipisDetails: [],

			errTitle: '', errMsg: '',
		};
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
		this.fetchBox();
		this.fetchPermintaan();
		this.fetchStokMenipisCount();
		this.fetchRekap();
		if (this.canAlokasi()) this.fetchUptList();
		if (this.canFilterKabupaten()) this.fetchKabupatenFilterList();
		if (this.canFilterUpt() && !this.canFilterKabupaten()) {
			// Kasi TU (minta/alokasi tanpa akses kelola) tidak dapat dropdown
			// Kabupaten (selalu kabupatennya sendiri) - langsung muat daftar
			// UPT dalam kabupaten sendiri (this.props.kabupaten_id), bukan
			// menunggu interaksi dropdown Kabupaten yang tidak ditampilkan.
			this.fetchUptFilterList(this.props.kabupaten_id);
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	canMinta = () => !!(this.props.akses && this.props.akses.gudang_notice_minta);
	canKelola = () => !!(this.props.akses && this.props.akses.gudang_notice_kelola);
	canAlokasi = () => !!(this.props.akses && this.props.akses.gudang_notice_alokasi);

	// Filter Kabupaten baru berguna utk role yang bisa lihat lintas kabupaten -
	// backend (BoxNoticeViewset.get_queryset) cuma memproses kabupaten_id utk
	// is_superuser/dapat_kelola_gudang_notice, selain itu diabaikan diam-diam.
	canFilterKabupaten = () => !!(this.props.is_superuser || this.canKelola());
	// Filter UPT berguna jg utk Kasi TU (minta/alokasi) - backend memprosesnya
	// utk mempersempit dari kabupaten sendiri (lihat get_queryset baris 216-233).
	canFilterUpt = () => !!(this.props.is_superuser || this.canKelola() || this.canMinta() || this.canAlokasi());

	fetchBox = (page = 1) => {
		const { boxPagination, filterBoxStatus, filterBoxKode, filterKabupatenId, filterUptId } = this.state;
		const limit = boxPagination.pageSize, offset = (page - 1) * limit;
		let params = `?limit=${limit}&offset=${offset}`;
		if (filterBoxStatus) params += `&status=${filterBoxStatus}`;
		if (filterBoxKode) params += `&kode_notice=${encodeURIComponent(filterBoxKode)}`;
		if (filterKabupatenId) params += `&kabupaten_id=${filterKabupatenId}`;
		if (filterUptId) params += `&upt_id=${filterUptId}`;
		this.setState({ loadingBox: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.box + params)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					const results = Array.isArray(data) ? data : (data.results || []);
					this.setState({
						listBox: results,
						boxPagination: { ...boxPagination, current: page, total: data.count || results.length },
					});
				}
				this.setState({ loadingBox: false });
			}).catch(() => this.setState({ loadingBox: false }));
	};

	// Dipakai khusus tampilan Visual - sengaja TIDAK pakai paginasi tabel
	// (limit besar, sekali ambil semua) supaya pengelompokan per-UPT/pool
	// tidak terpotong per-halaman. Aman karena box 'habis' (yang menumpuk
	// seiring waktu) dikeluarkan di sini - sisanya (gudang/diterima/
	// dialokasikan/aktif) jumlahnya sebanding dengan jumlah UPT yang masih
	// aktif pakai sistem ini, bukan dengan volume transaksi/tahun berjalan
	// (lihat diskusi sebelum fitur ini dibuat). limit=1000 cuma pengaman,
	// bukan batas yang realistis akan tersentuh.
	fetchBoxVisual = () => {
		const { filterKabupatenId, filterUptId } = this.state;
		let params = '?limit=1000';
		if (filterKabupatenId) params += `&kabupaten_id=${filterKabupatenId}`;
		if (filterUptId) params += `&upt_id=${filterUptId}`;
		this.setState({ loadingBoxVisual: true });
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.box}${params}`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					const results = Array.isArray(data) ? data : (data.results || []);
					this.setState({ listBoxVisual: results.filter((b) => b.status !== 'habis') });
				}
				this.setState({ loadingBoxVisual: false });
			}).catch(() => this.setState({ loadingBoxVisual: false }));
	};

	// Dipakai tab "Rekap Stok" - beda dgn fetchBoxVisual (yg sengaja buang
	// status 'habis' utk tampilan board per-UPT), di sini SEMUA status
	// (termasuk 'habis') ikut diambil krn justru itu salah satu kategori
	// yang mau ditampilkan jumlahnya.
	fetchRekap = () => {
		const { filterKabupatenId, filterUptId } = this.state;
		let params = '?limit=1000';
		if (filterKabupatenId) params += `&kabupaten_id=${filterKabupatenId}`;
		if (filterUptId) params += `&upt_id=${filterUptId}`;
		this.setState({ loadingRekap: true });
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.box}${params}`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					const results = Array.isArray(data) ? data : (data.results || []);
					this.setState({ listRekap: results });
				}
				this.setState({ loadingRekap: false });
			}).catch(() => this.setState({ loadingRekap: false }));
	};

	fetchKabupatenFilterList = (search = '') => {
		this.setState({ loadingKabupatenFilter: true });
		this.props.ajaxViewHandler('get', `master/api/kabupaten/?limit=200${search ? '&search=' + encodeURIComponent(search) : ''}`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState({ listKabupatenFilter: Array.isArray(data) ? data : (data.results || []) });
				}
				this.setState({ loadingKabupatenFilter: false });
			}).catch(() => this.setState({ loadingKabupatenFilter: false }));
	};

	fetchUptFilterList = (kabupatenId, search = '') => {
		this.setState({ loadingUptFilter: true });
		const kabParam = kabupatenId ? `&kabupaten=${kabupatenId}` : '';
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.upt}?limit=200${kabParam}${search ? '&search=' + encodeURIComponent(search) : ''}`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState({ listUptFilter: Array.isArray(data) ? data : (data.results || []) });
				}
				this.setState({ loadingUptFilter: false });
			}).catch(() => this.setState({ loadingUptFilter: false }));
	};

	// Refetch sumber data yang relevan dgn tab/mode yang sedang aktif, dipanggil
	// tiap filter Kabupaten/UPT berubah. Rekap Stok SELALU ikut di-refresh -
	// kartunya tampil permanen di luar tab (tidak tergantung activeTab).
	_refetchAfterFilterChange = () => {
		const { activeTab, boxViewMode } = this.state;
		this.fetchRekap();
		if (activeTab === 'box') {
			if (boxViewMode === 'visual') this.fetchBoxVisual(); else this.fetchBox(1);
		}
	};

	handleFilterKabupatenChange = (val) => {
		this.setState({ filterKabupatenId: val, filterUptId: undefined }, () => {
			this.fetchUptFilterList(val);
			this._refetchAfterFilterChange();
		});
	};

	handleFilterUptChange = (val) => {
		this.setState({ filterUptId: val }, () => this._refetchAfterFilterChange());
	};

	fetchPermintaan = (page = 1) => {
		const { permintaanPagination } = this.state;
		const limit = permintaanPagination.pageSize, offset = (page - 1) * limit;
		this.setState({ loadingPermintaan: true });
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.permintaan}?limit=${limit}&offset=${offset}`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					const results = Array.isArray(data) ? data : (data.results || []);
					this.setState({
						listPermintaan: results,
						permintaanPagination: { ...permintaanPagination, current: page, total: data.count || results.length },
					});
				}
				this.setState({ loadingPermintaan: false });
			}).catch(() => this.setState({ loadingPermintaan: false }));
	};

	fetchStokMenipisCount = () => {
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.box}stok-menipis-count/`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg || {};
					this.setState({
						stokMenipisCount: data.count || 0,
						stokMenipisThreshold: data.threshold || 100,
						stokMenipisDetails: data.details || [],
					});
				}
			});
	};

	fetchUptList = (search = '') => {
		this.setState({ loadingUpt: true });
		// Kasi TU hanya boleh menempatkan/memindah box ke UPT/loket di
		// kabupatennya sendiri - batasi pilihan UPT di dropdown sesuai itu.
		const kabupatenParam = this.props.kabupaten_id ? `&kabupaten=${this.props.kabupaten_id}` : '';
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.upt}?limit=200${kabupatenParam}${search ? '&search=' + encodeURIComponent(search) : ''}`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState({ listUpt: Array.isArray(data) ? data : (data.results || []) });
				}
				this.setState({ loadingUpt: false });
			}).catch(() => this.setState({ loadingUpt: false }));
	};

	// Popup error modern (ErrorAlertModal) pengganti message.error untuk
	// kegagalan aksi (alokasikan/kembalikan/dll) - pesan dari backend
	// bisa cukup panjang (nama UPT, penjelasan multi-kalimat) jadi tidak pas
	// di toast singkat, dan support **bold** markdown dari backend langsung.
	_showError = (title, fallback) => {
		const msg = this.props.responseMsg;
		const errMsg = (typeof msg === 'string' ? msg : (msg && msg.error)) || fallback;
		this.setState({ errTitle: title, errMsg });
	};

	openKembalikan = (row) => {
		if (!['diterima', 'dialokasikan'].includes(row.status)) {
			message.warning({ content: 'Box aktif/habis tidak bisa ditarik dari sini.', duration: 2, key: 'toast' });
			return;
		}
		this.setState({ modalKembalikan: true, kembalikanTarget: row });
	};

	confirmKembalikan = () => {
		const { kembalikanTarget } = this.state;
		if (!kembalikanTarget) return;
		this.setState({ loadingKembalikan: true });
		this.props.ajaxHandler('post', `${configClass.apiUrl.box}kembalikan/`, {
			box_ids: [kembalikanTarget.id],
		}, false, true).then(() => {
			if (this.props.isSuccess) {
				message.success({ content: 'Box berhasil dikembalikan ke gudang pusat.', duration: 2, key: 'toast' });
				this.setState({ modalKembalikan: false, kembalikanTarget: null });
				this.fetchBox();
				this.fetchStokMenipisCount();
			} else {
				this._showError('Gagal Mengembalikan Box', 'Gagal mengembalikan box.');
			}
			this.setState({ loadingKembalikan: false });
		}).catch(() => { this._showError('Gagal Mengirim', 'Gagal mengirim, coba lagi.'); this.setState({ loadingKembalikan: false }); });
	};

	// Beda dgn handleKembalikan: tetap di kabupaten yang sama (lepas dari UPT
	// saja, balik ke pool "Diterima (Belum Ditempatkan)") - dipakai Kasi TU
	// sendiri tanpa eskalasi ke otoritas pusat. Box 'dialokasikan' selalu
	// boleh (belum pernah dipakai). Box 'aktif' cuma indikasi cepat di sini
	// (sisa_notice == kapasitas penuh, berarti BELUM PERNAH dipakai sama
	// sekali - salah tempatkan, mau ditukar) - bukan keputusan final, backend
	// tetap re-verifikasi ke histori Tagihan sebelum benar-benar memproses
	// (lihat be/gudangnotice/views.py, action 'lepas') supaya tidak kebobolan
	// kalau tampilan sempat stale.
	_bisaLepas = (row) => {
		if (row.status === 'dialokasikan') return true;
		if (row.status === 'aktif') {
			const kapasitas = row.nomor_akhir - row.nomor_awal + 1;
			return row.sisa_notice === kapasitas;
		}
		return false;
	};

	openLepas = (row) => {
		if (!this._bisaLepas(row)) {
			message.warning({ content: 'Box ini tidak bisa dilepas - hanya box "Dialokasikan", atau box "Aktif" yang belum pernah dipakai sama sekali.', duration: 2, key: 'toast' });
			return;
		}
		this.setState({ modalLepas: true, lepasTarget: row });
	};

	confirmLepas = () => {
		const { lepasTarget } = this.state;
		if (!lepasTarget) return;
		this.setState({ loadingLepas: true });
		this.props.ajaxHandler('post', `${configClass.apiUrl.box}lepas/`, {
			box_ids: [lepasTarget.id],
		}, false, true).then(() => {
			if (this.props.isSuccess) {
				message.success({ content: 'Box berhasil dilepas dari UPT.', duration: 2, key: 'toast' });
				this.setState({ modalLepas: false, lepasTarget: null });
				this.fetchBox();
				this.fetchStokMenipisCount();
			} else {
				this._showError('Gagal Melepas Box', 'Gagal melepas box.');
			}
			this.setState({ loadingLepas: false });
		}).catch(() => { this._showError('Gagal Mengirim', 'Gagal mengirim, coba lagi.'); this.setState({ loadingLepas: false }); });
	};

	openAlokasikan = (row) => {
		this.fetchUptList();
		this.setState({ modalAlokasikan: true, alokasikanTargetBox: row, alokasikanUptId: undefined, konfirmasiPindahAktif: false });
	};

	handleAlokasikan = () => {
		const { alokasikanTargetBox, alokasikanUptId, konfirmasiPindahAktif } = this.state;
		if (!alokasikanTargetBox) return;
		if (!alokasikanUptId) { message.warning({ content: 'Pilih UPT tujuan terlebih dahulu.', duration: 2, key: 'toast' }); return; }
		if (alokasikanTargetBox.status === 'aktif' && !konfirmasiPindahAktif) {
			message.warning({ content: 'Centang konfirmasi pemindahan box aktif terlebih dahulu.', duration: 2, key: 'toast' });
			return;
		}
		this.setState({ loadingAlokasikan: true });
		this.props.ajaxHandler('post', `${configClass.apiUrl.box}alokasikan/`, {
			box_ids: [alokasikanTargetBox.id],
			upt_id: alokasikanUptId,
		}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					const jumlahAktifDipindah = (this.props.responseMsg && this.props.responseMsg.jumlah_aktif_dipindah) || 0;
					message.success({
						content: jumlahAktifDipindah > 0
							? 'Box berhasil dipindahkan ke UPT, termasuk box yang sedang aktif dipakai (lanjut dari posisi terakhir).'
							: 'Box berhasil dialokasikan ke UPT.',
						duration: 2,
						key: 'toast',
					});
					this.setState({ modalAlokasikan: false, alokasikanTargetBox: null, alokasikanUptId: undefined, konfirmasiPindahAktif: false });
					this.fetchBox();
					this.fetchStokMenipisCount();
				} else {
					this._showError('Gagal Mengalokasikan Box', 'Gagal mengalokasikan box.');
				}
				this.setState({ loadingAlokasikan: false });
			}).catch(() => { this._showError('Gagal Mengirim', 'Gagal mengirim, coba lagi.'); this.setState({ loadingAlokasikan: false }); });
	};

	// Ringkasan konfirmasi sebelum submit final (permintaan user - salah input
	// nomor mulai rawan terjadi krn field ini manual) - baru panggil handler
	// yang benar2 mengirim ke backend setelah user menekan "Ya, Tambahkan".
	handleTambahBoxSubmit = (values) => {
		const { cekKodeInfo } = this.state;
		const saran = cekKodeInfo && cekKodeInfo.saranNomorMulai;
		const nomorAwal = values.nomor_awal;
		const nomorAkhir = nomorAwal + values.jumlah_box * 1000 - 1;
		const menyimpang = saran != null && Math.abs(Number(nomorAwal) - Number(saran)) >= 1000;
		Modal.confirm({
			title: 'Konfirmasi Tambah Box Notice',
			icon: <PlusOutlined style={{ color: '#1e4d8a' }} />,
			width: 480,
			content: (
				<div style={{ fontSize: 13.5 }}>
					<div style={{ marginBottom: 10 }}>
						Kode <b style={{ fontFamily: 'monospace' }}>{values.kode_notice}</b>, sebanyak{' '}
						<b>{values.jumlah_box}</b> box, rentang nomor:
					</div>
					<div style={{
						fontFamily: 'monospace', fontSize: 15, fontWeight: 700, textAlign: 'center',
						background: '#f5f8fc', border: '1px solid #e3ecf7', borderRadius: 8, padding: '10px 12px', marginBottom: 10,
					}}>
						{String(nomorAwal).padStart(7, '0')} – {String(nomorAkhir).padStart(7, '0')}
					</div>
					{menyimpang && (
						<Alert
							type="warning"
							showIcon
							style={{ marginBottom: 4, borderRadius: 8 }}
							message="Nomor mulai menyimpang jauh dari saran sistem"
							description={`Saran sistem: ${String(saran).padStart(7, '0')}. Pastikan angka ini sudah dicocokkan dengan catatan pengadaan fisik sebelum lanjut.`}
						/>
					)}
				</div>
			),
			okText: 'Ya, Tambahkan',
			cancelText: 'Periksa Lagi',
			onOk: () => this.handleTambahBox(values),
		});
	};

	handleTambahBox = (values) => {
		this.setState({ loadingTambahBox: true });
		this.props.ajaxHandler('post', `${configClass.apiUrl.box}tambah/`, {
			kode_notice: values.kode_notice,
			jumlah_box: values.jumlah_box,
			nomor_awal: values.nomor_awal,
		}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Box notice berhasil ditambahkan.', duration: 2, key: 'toast' });
					this.setState({ modalTambahBox: false, cekKodeInfo: null, lastSaranPrefilled: null });
					if (this.formTambahBoxRef.current) this.formTambahBoxRef.current.resetFields();
					this.fetchBox();
				} else {
					this._showError('Gagal Menambah Box', 'Gagal menambah box.');
				}
				this.setState({ loadingTambahBox: false });
			}).catch(() => { this._showError('Gagal Mengirim', 'Gagal mengirim, coba lagi.'); this.setState({ loadingTambahBox: false }); });
	};

	// Saran nomor mulai (backend, action 'saran_nomor_mulai') sudah
	// mempertimbangkan box terdaftar MAUPUN histori Tagihan lintas UPT yang
	// masih di counter legacy bebas - lebih akurat drpd sekadar melihat box
	// terakhir kode ini. Field "Nomor Mulai" tetap manual/editable (user
	// wajib cocokkan dgn catatan pengadaan fisik), saran ini cuma pre-fill
	// titik awal supaya tidak menebak-nebak dari nol.
	cekKodeNotice = (kodeRaw) => {
		const kode = (kodeRaw || '').trim().toUpperCase();
		if (!kode) {
			this.setState({ cekKodeInfo: null, cekKodeLoading: false });
			return;
		}
		this.setState({ cekKodeLoading: true });
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.box}saran_nomor_mulai/?kode_notice=${encodeURIComponent(kode)}`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg || {};
					const saran = data.saran_nomor_mulai || 1;
					this.setState({
						cekKodeInfo: {
							nomorBoxTerakhir: data.nomor_box_terakhir || 0,
							nomorTagihanTertinggi: data.nomor_tagihan_tertinggi || 0,
							saranNomorMulai: saran,
						},
						cekKodeLoading: false,
					}, () => this._prefillNomorAwal(saran));
				} else {
					this.setState({ cekKodeInfo: null, cekKodeLoading: false });
				}
			}).catch(() => this.setState({ cekKodeLoading: false }));
	};

	// Cuma auto-isi kalau field masih kosong ATAU masih persis sama dgn saran
	// SEBELUMNYA (user belum sengaja mengetik nilai manual sendiri) - supaya
	// tidak menimpa input yang sudah dikoreksi user begitu kode di-blur ulang.
	_prefillNomorAwal = (saran) => {
		const form = this.formTambahBoxRef.current;
		if (!form) return;
		const current = form.getFieldValue('nomor_awal');
		const { lastSaranPrefilled } = this.state;
		if (current == null || current === '' || current === lastSaranPrefilled) {
			form.setFieldsValue({ nomor_awal: saran });
		}
		this.setState({ lastSaranPrefilled: saran });
	};

	handleAjukan = (values) => {
		this.setState({ loadingAjukan: true });
		this.props.ajaxHandler('post', configClass.apiUrl.permintaan, {
			jumlah_box: values.jumlah_box,
			keterangan: values.keterangan || '',
		}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Permintaan stok notice berhasil diajukan.', duration: 2, key: 'toast' });
					this.setState({ modalAjukan: false });
					if (this.formAjukanRef.current) this.formAjukanRef.current.resetFields();
					this.fetchPermintaan();
				} else {
					this._showError('Gagal Mengajukan Permintaan', 'Gagal mengajukan permintaan.');
				}
				this.setState({ loadingAjukan: false });
			}).catch(() => { this._showError('Gagal Mengirim', 'Gagal mengirim, coba lagi.'); this.setState({ loadingAjukan: false }); });
	};

	fetchKodeTersedia = () => {
		this.setState({ loadingKodeTersedia: true });
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.box}kode-tersedia/`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState({ kodeTersediaList: Array.isArray(data) ? data : [], loadingKodeTersedia: false },
						() => this.recomputeAlokasi());
				} else {
					this.setState({ loadingKodeTersedia: false });
				}
			}).catch(() => this.setState({ loadingKodeTersedia: false }));
	};

	// Stok tersedia per kode, dengan kode yang diminta Kasi TU tetap muncul
	// (ditandai habis) walau stok gudang-nya 0, supaya kelihatan jelas.
	_getOpsiKode = () => {
		const { kodeTersediaList, selectedPermintaan } = this.state;
		const opsiKode = [...kodeTersediaList];
		const kodeDiminta = selectedPermintaan && selectedPermintaan.kode_notice_diminta;
		if (kodeDiminta && !opsiKode.some((k) => k.kode_notice === kodeDiminta)) {
			opsiKode.unshift({ kode_notice: kodeDiminta, jumlah_box: 0 });
		}
		return opsiKode;
	};

	// Jumlah box per baris alokasi TIDAK diisi manual - selalu dihitung ulang
	// dari stok yang tersedia untuk kode yang dipilih, dibatasi sisa kebutuhan
	// permintaan (supaya tidak pernah melebihi/under tanpa sepengetahuan user).
	// Kalau baris itu sudah punya panel kandidat box terbuka dengan sebagian
	// dikecualikan, batasi juga ke sisa yang masih tercentang di panel itu -
	// supaya recompute (mis. gara2 nambah/hapus baris kode lain) tidak diam2
	// "membatalkan" pengecualian yang sudah dipilih user.
	recomputeAlokasi = () => {
		const form = this.formApproveRef.current;
		const { selectedPermintaan, kandidatPanel } = this.state;
		if (!form || !selectedPermintaan) return;
		const opsiKode = this._getOpsiKode();
		const current = form.getFieldValue('alokasi') || [];
		let remaining = selectedPermintaan.jumlah_box;
		const updated = current.map((row) => {
			if (!row || !row.kode_notice) return { ...row, jumlah: 0 };
			const stokInfo = opsiKode.find((k) => k.kode_notice === row.kode_notice);
			let stokTersedia = stokInfo ? stokInfo.jumlah_box : 0;
			const panel = kandidatPanel[row.kode_notice];
			if (panel && panel.list.length > 0) {
				stokTersedia = Math.min(stokTersedia, panel.list.length - panel.excluded.length);
			}
			const jumlah = Math.max(0, Math.min(stokTersedia, remaining));
			remaining -= jumlah;
			return { ...row, jumlah };
		});
		form.setFieldsValue({ alokasi: updated });
	};

	openRiwayat = (row) => {
		this.setState({ modalRiwayat: true, riwayatBox: row, loadingRiwayat: true, riwayatList: [] });
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.box}${row.id}/riwayat/`)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState({ riwayatList: Array.isArray(data) ? data : [] });
				}
				this.setState({ loadingRiwayat: false });
			}).catch(() => this.setState({ loadingRiwayat: false }));
	};

	openApprove = (row) => {
		this.setState({ modalApprove: true, selectedPermintaan: row, catatanApproval: '', kandidatPanel: {} });
		this.fetchKodeTersedia();
	};

	// Daftar kandidat box 'gudang' utk 1 kode_notice, urut FIFO (nomor_box
	// terkecil dulu - lihat catatan di action 'approve' be/gudangnotice/
	// views.py). Staf cuma bisa MENGECUALIKAN box tertentu dari daftar ini
	// (mis. fisiknya rusak/hilang) - tidak bisa pilih bebas/loncat urutan,
	// supaya box yang lebih lama tidak pernah "ketinggalan" tanpa alasan.
	toggleKandidatPanel = (kode, jumlah) => {
		const existing = this.state.kandidatPanel[kode];
		if (existing) {
			this.setState((prev) => ({ kandidatPanel: { ...prev.kandidatPanel, [kode]: { ...existing, open: !existing.open } } }));
			return;
		}
		if (jumlah <= 0) {
			// limit=0 ambigu di paginasi DRF (bisa kebaca "tanpa batas" alih2
			// "nol") - jangan sampai fetch, langsung tampilkan panel kosong.
			this.setState((prev) => ({ kandidatPanel: { ...prev.kandidatPanel, [kode]: { open: true, loading: false, list: [], excluded: [] } } }));
			return;
		}
		this.setState((prev) => ({ kandidatPanel: { ...prev.kandidatPanel, [kode]: { open: true, loading: true, list: [], excluded: [] } } }));
		// limit = jumlah persis (bukan buffer lebih besar) - TIDAK ada "ambil
		// box pengganti dari lebih dalam stok" kalau ada yang dikecualikan;
		// mengecualikan box di sini murni mengurangi jumlah yang diambil dari
		// kode ini (lihat _syncJumlahFromKandidat) - staf yang menutup
		// kekurangannya lewat baris kode lain kalau perlu.
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.box}?status=gudang&kode_notice=${encodeURIComponent(kode)}&limit=${jumlah}`)
			.then(() => {
				const panelLama = this.state.kandidatPanel[kode] || { open: true, excluded: [] };
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					const results = Array.isArray(data) ? data : (data.results || []);
					// kode_notice di backend pakai icontains - filter exact lagi di
					// sini supaya tidak ikut menampilkan kode lain yang kebetulan
					// substring (mis. kode "A" vs "A1").
					const list = results.filter((b) => b.kode_notice === kode);
					this.setState((prev) => ({ kandidatPanel: { ...prev.kandidatPanel, [kode]: { ...panelLama, loading: false, list } } }),
						() => this._syncJumlahFromKandidat(kode));
				} else {
					this.setState((prev) => ({ kandidatPanel: { ...prev.kandidatPanel, [kode]: { ...panelLama, loading: false } } }));
				}
			}).catch(() => {
				const panelLama = this.state.kandidatPanel[kode] || { open: true, excluded: [] };
				this.setState((prev) => ({ kandidatPanel: { ...prev.kandidatPanel, [kode]: { ...panelLama, loading: false } } }));
			});
	};

	toggleExcludeBox = (kode, boxId) => {
		this.setState((prev) => {
			const panel = prev.kandidatPanel[kode];
			if (!panel) return {};
			const excluded = panel.excluded.includes(boxId)
				? panel.excluded.filter((id) => id !== boxId)
				: [...panel.excluded, boxId];
			return { kandidatPanel: { ...prev.kandidatPanel, [kode]: { ...panel, excluded } } };
		}, () => this._syncJumlahFromKandidat(kode));
	};

	// Jumlah box yang akan benar2 diambil dari 1 kode = jumlah box kandidat
	// yang masih tercentang (tidak dikecualikan) - bukan target FIFO awal.
	// Disinkronkan ke field 'jumlah' baris itu supaya kolom kanan & ringkasan
	// "Total dialokasikan: X / target" otomatis ikut berkurang, dan tidak
	// pernah bisa melebihi target permintaan (jumlah awal per baris sudah
	// dibatasi recomputeAlokasi(), pengecualian hanya bisa menguranginya).
	_syncJumlahFromKandidat = (kode) => {
		const panel = this.state.kandidatPanel[kode];
		const form = this.formApproveRef.current;
		if (!panel || !form) return;
		const alokasiAll = form.getFieldValue('alokasi') || [];
		const idx = alokasiAll.findIndex((a) => a && a.kode_notice === kode);
		if (idx === -1) return;
		const efektif = Math.max(0, panel.list.length - panel.excluded.length);
		if (Number(alokasiAll[idx].jumlah) === efektif) return;
		const updated = [...alokasiAll];
		updated[idx] = { ...updated[idx], jumlah: efektif };
		form.setFieldsValue({ alokasi: updated });
	};

	// Shift+klik range-select ala file explorer - BUKAN bawaan otomatis antd
	// (rowSelection.onChange saja cuma toggle 1 baris per klik). Beroperasi
	// atas listBox HALAMAN SAAT INI (urutan render = urutan data), cukup utk
	// pemakaian nyata (1 batch tambah() biasanya masih dalam 1 halaman).
	// Baris non-'gudang' sengaja dilewati dari hasil rentang - konsisten dgn
	// getCheckboxProps yang sudah men-disable baris itu di checkbox individu.
	handleBoxRowSelect = (record, selected, _selectedRows, nativeEvent) => {
		const { listBox, lastSelectedBoxRowIndex, selectedBoxRowKeys } = this.state;
		const currentIndex = listBox.findIndex((b) => b.id === record.id);
		const isShiftRange = nativeEvent && nativeEvent.shiftKey && lastSelectedBoxRowIndex != null && currentIndex !== -1;
		if (isShiftRange) {
			const [start, end] = [lastSelectedBoxRowIndex, currentIndex].sort((a, b) => a - b);
			const rangeIds = listBox.slice(start, end + 1).filter((b) => b.status === 'gudang').map((b) => b.id);
			const nextKeys = selected
				? Array.from(new Set([...selectedBoxRowKeys, ...rangeIds]))
				: selectedBoxRowKeys.filter((id) => !rangeIds.includes(id));
			this.setState({ selectedBoxRowKeys: nextKeys, lastSelectedBoxRowIndex: currentIndex });
			return;
		}
		const nextKeys = selected
			? Array.from(new Set([...selectedBoxRowKeys, record.id]))
			: selectedBoxRowKeys.filter((id) => id !== record.id);
		this.setState({ selectedBoxRowKeys: nextKeys, lastSelectedBoxRowIndex: currentIndex });
	};

	handleBoxSelectAll = (selected) => {
		const eligibleIds = this.state.listBox.filter((b) => b.status === 'gudang').map((b) => b.id);
		this.setState((prev) => ({
			selectedBoxRowKeys: selected
				? Array.from(new Set([...prev.selectedBoxRowKeys, ...eligibleIds]))
				: prev.selectedBoxRowKeys.filter((id) => !eligibleIds.includes(id)),
			lastSelectedBoxRowIndex: null,
		}));
	};

	openHapusBatch = () => {
		if (this.state.selectedBoxRowKeys.length === 0) return;
		this.setState({ modalHapusBatch: true });
	};

	confirmHapusBatch = () => {
		const { selectedBoxRowKeys } = this.state;
		this.setState({ loadingHapusBatch: true });
		this.props.ajaxHandler('post', `${configClass.apiUrl.box}hapus_batch/`, {
			box_ids: selectedBoxRowKeys,
		}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					const jumlah = (this.props.responseMsg && this.props.responseMsg.jumlah_dihapus) || selectedBoxRowKeys.length;
					message.success({ content: `${jumlah} box berhasil dihapus.`, duration: 2, key: 'toast' });
					this.setState({ modalHapusBatch: false, selectedBoxRowKeys: [], lastSelectedBoxRowIndex: null });
					this.fetchBox();
				} else {
					this._showError('Gagal Menghapus Box', 'Gagal menghapus box - pastikan seluruh box dari 1 kali penambahan (batch) yang sama dipilih sekaligus.');
				}
				this.setState({ loadingHapusBatch: false });
			}).catch(() => { this._showError('Gagal Mengirim', 'Gagal mengirim, coba lagi.'); this.setState({ loadingHapusBatch: false }); });
	};

	openReject = (row) => {
		this.setState({ modalReject: true, selectedPermintaan: row, catatanApproval: '' });
	};

	handleApprove = (values) => {
		const { selectedPermintaan, catatanApproval, kandidatPanel } = this.state;
		this.setState({ loadingAction: true });
		const alokasi = (values.alokasi || []).map((row) => ({
			kode_notice: row.kode_notice,
			jumlah: row.jumlah,
			exclude_box_ids: (kandidatPanel[row.kode_notice] && kandidatPanel[row.kode_notice].excluded) || [],
		}));
		this.props.ajaxHandler('post', `${configClass.apiUrl.permintaan}${selectedPermintaan.id}/approve/`, {
			alokasi,
			catatan_approval: catatanApproval,
		}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Permintaan stok notice disetujui & box berhasil dialokasikan.', duration: 2, key: 'toast' });
					this.setState({ modalApprove: false });
					this.fetchPermintaan();
					this.fetchBox();
				} else {
					this._showError('Gagal Menyetujui Permintaan', 'Gagal menyetujui permintaan.');
				}
				this.setState({ loadingAction: false });
			}).catch(() => { this._showError('Gagal Mengirim', 'Gagal mengirim, coba lagi.'); this.setState({ loadingAction: false }); });
	};

	handleReject = () => {
		const { selectedPermintaan, catatanApproval } = this.state;
		this.setState({ loadingAction: true });
		this.props.ajaxHandler('post', `${configClass.apiUrl.permintaan}${selectedPermintaan.id}/reject/`, {
			catatan_approval: catatanApproval,
		}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'Permintaan stok notice ditolak.', duration: 2, key: 'toast' });
					this.setState({ modalReject: false });
					this.fetchPermintaan();
				} else {
					this._showError('Gagal Menolak Permintaan', 'Gagal menolak permintaan.');
				}
				this.setState({ loadingAction: false });
			}).catch(() => { this._showError('Gagal Mengirim', 'Gagal mengirim, coba lagi.'); this.setState({ loadingAction: false }); });
	};

	// Dipakai bersama oleh kolom Aksi tabel DAN tombol aksi di kartu tampilan
	// Visual - 1 sumber kebenaran untuk handler & kondisi disabled, supaya
	// kedua tampilan tidak pernah berbeda perilaku.
	_renderBoxActions = (row) => {
		const canAlokasi = this.canAlokasi();
		const canKelola = this.canKelola();
		return (
			<div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
				<Tooltip title="Lihat riwayat perpindahan box ini">
					<Button
						className="gudang-aksi-btn"
						shape="circle"
						size="small"
						icon={<HistoryOutlined />}
						onClick={() => this.openRiwayat(row)}
					/>
				</Tooltip>
				{canAlokasi && (
					<Tooltip title="Tempatkan/pindahkan box ini ke UPT supaya bisa langsung dipakai menerbitkan notice (atau disiapkan sebagai stok cadangan)">
						<Button
							className="gudang-aksi-btn"
							shape="circle"
							size="small"
							type="primary"
							disabled={!['diterima', 'dialokasikan', 'aktif'].includes(row.status)}
							style={{ background: '#1e4d8a', borderColor: '#1e4d8a' }}
							icon={<SendOutlined />}
							onClick={() => this.openAlokasikan(row)}
						/>
					</Tooltip>
				)}
				{canAlokasi && (
					<Tooltip title={
						row.status === 'aktif'
							? 'Lepas box ini dari UPT - hanya bisa kalau belum pernah dipakai menerbitkan notice sama sekali (salah tempatkan, mau ditukar)'
							: "Lepas box ini dari UPT saat ini, balik ke pool kabupaten ('Diterima - Belum Ditempatkan') supaya bisa dialokasikan ulang ke UPT lain"
					}>
						<Button
							className="gudang-aksi-btn"
							shape="circle"
							size="small"
							icon={<DisconnectOutlined />}
							disabled={!this._bisaLepas(row)}
							onClick={() => this.openLepas(row)}
						/>
					</Tooltip>
				)}
				{canKelola && (
					<Tooltip title="Tarik box ini kembali ke gudang pusat (lepas dari kabupaten/UPT saat ini)">
						<Button
							className="gudang-aksi-btn"
							shape="circle"
							size="small"
							icon={<UndoOutlined />}
							disabled={!['diterima', 'dialokasikan'].includes(row.status)}
							onClick={() => this.openKembalikan(row)}
						/>
					</Tooltip>
				)}
			</div>
		);
	};

	_boxColumns() {
		return [
			{ title: 'Kode', dataIndex: 'kode_notice', key: 'kode_notice', width: 90,
				render: (v) => <Text style={{ fontFamily: 'monospace', fontWeight: 700 }}>{v}</Text> },
			{ title: 'No. Box', dataIndex: 'nomor_box', key: 'nomor_box', width: 90, align: 'center' },
			{ title: 'Rentang Nomor', key: 'rentang', width: 200,
				render: (_, row) => <Text style={{ fontFamily: 'monospace' }}>{String(row.nomor_awal).padStart(7, '0')} – {String(row.nomor_akhir).padStart(7, '0')}</Text> },
			{ title: 'Status', dataIndex: 'status', key: 'status', width: 190, align: 'center',
				render: (v) => <StatusTag map={BOX_STATUS} value={v} /> },
			{ title: 'Sisa Stok', dataIndex: 'sisa_notice', key: 'sisa_notice', width: 110, align: 'center',
				render: (v) => {
					if (v == null) return <Text type="secondary">—</Text>;
					const menipis = v <= 100;
					return <Tag color={menipis ? 'red' : (v <= 300 ? 'orange' : 'green')}>{v} lembar</Tag>;
				} },
			{ title: 'Kabupaten (pool)', dataIndex: 'kabupaten_nama', key: 'kabupaten_nama', render: (v) => v && v !== '-' ? v : <Text type="secondary">—</Text> },
			{ title: 'UPT', dataIndex: 'upt_nama', key: 'upt_nama', render: (v) => v || <Text type="secondary">—</Text> },
			{ title: 'Ditambahkan Oleh', dataIndex: 'ditambahkan_oleh_nama', key: 'ditambahkan_oleh_nama', render: (v) => v || <Text type="secondary">—</Text> },
			{ title: 'Dialokasikan Oleh', dataIndex: 'dialokasikan_oleh_nama', key: 'dialokasikan_oleh_nama', render: (v) => v || <Text type="secondary">—</Text> },
			{
				title: 'Aksi', key: 'aksi', width: 160, fixed: 'right', align: 'center',
				render: (_, row) => this._renderBoxActions(row),
			},
		];
	}

	// Kartu ringkasan tab "Rekap Stok" - 5 kategori status (lihat
	// REKAP_CATEGORIES/BOX_STATUS), masing-masing diklik utk drill-down ke
	// tab "Stok Box" (tabel) dgn filterBoxStatus otomatis ter-set ke kategori
	// itu. Jumlah lembar dihitung dari kapasitas box (nomor_akhir-nomor_awal+1),
	// BUKAN sisa stok riil (itu perlu join ke PengaturanNotice per UPT yang
	// lebih berat - cukup dgn jumlah box + kapasitas utk kebutuhan "mudah
	// dibaca sekilas" di tab ini; sisa stok riil tetap ada di kolom tabel).
	renderRekapStok() {
		const { listRekap, loadingRekap, isMobile } = this.state;
		if (loadingRekap) {
			return <div style={{ textAlign: 'center', padding: 50 }}><Spin size="large" /></div>;
		}
		if (listRekap.length === 0) {
			return <Empty description="Belum ada box notice" style={{ padding: '20px 0' }} />;
		}
		const byStatus = {};
		listRekap.forEach((b) => {
			if (!byStatus[b.status]) byStatus[b.status] = { jumlah: 0, lembar: 0 };
			byStatus[b.status].jumlah += 1;
			byStatus[b.status].lembar += (b.nomor_akhir - b.nomor_awal + 1);

			// Box 'aktif' yang sisa_notice (dihitung backend dari PengaturanNotice,
			// lihat BoxNoticeSerializer.get_sisa_notice) sudah <=0 SECARA FUNGSI
			// sudah habis - tapi field status baru benar-benar berubah jadi
			// 'habis' saat transaksi BERIKUTNYA dicoba (lihat _get_next_notice di
			// transaksi/views.py), jadi kartu "Habis Terpakai" bisa tampil 0
			// padahal ada box yang nyatanya sudah habis. Ikut dihitung di sini
			// juga - SENGAJA TIDAK mengurangi hitungan kategori 'aktif' di atas
			// (box ini tetap dihitung apa adanya di kedua kartu).
			if (b.status === 'aktif' && b.sisa_notice != null && b.sisa_notice <= 0) {
				if (!byStatus.habis) byStatus.habis = { jumlah: 0, lembar: 0 };
				byStatus.habis.jumlah += 1;
				byStatus.habis.lembar += (b.nomor_akhir - b.nomor_awal + 1);
			}
		});
		return (
			<div style={{ display: 'flex', flexWrap: 'wrap', gap: isMobile ? 10 : 14, marginBottom: isMobile ? 4 : 8 }}>
				{REKAP_CATEGORIES.map((cat) => {
					const s = BOX_STATUS[cat.status];
					const d = byStatus[cat.status] || { jumlah: 0, lembar: 0 };
					return (
						<div
							key={cat.status}
							className="gudang-rekap-card"
							onClick={() => this.setState({
								activeTab: 'box', boxViewMode: 'table', filterBoxStatus: cat.status,
							}, () => this.fetchBox(1))}
							style={{
								cursor: 'pointer', background: '#fff', borderRadius: 12,
								padding: isMobile ? '12px 14px' : '16px 20px',
								border: `1px solid ${s.border}`, boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
								flex: isMobile ? '1 1 calc(50% - 5px)' : '1 1 180px', minWidth: 0,
								transition: 'transform 0.15s ease, box-shadow 0.15s ease',
							}}
						>
							<div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8 }}>
								<div style={{
									width: isMobile ? 26 : 32, height: isMobile ? 26 : 32, borderRadius: 8, background: s.color,
									display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: isMobile ? 13 : 15, color: s.text,
									flexShrink: 0,
								}}>
									{cat.icon}
								</div>
								<span style={{
									fontSize: isMobile ? 10 : 11, color: '#64748b', fontWeight: 700,
									textTransform: 'uppercase', letterSpacing: .5, lineHeight: 1.2,
								}}>
									{s.label}
								</span>
							</div>
							<div style={{ fontSize: isMobile ? 18 : 22, fontWeight: 900, color: s.text }}>{d.jumlah} box</div>
							<div style={{ fontSize: isMobile ? 11 : 12, color: '#94a3b8', marginTop: 2, fontFamily: 'monospace' }}>
								{d.lembar.toLocaleString('id-ID')} lembar
							</div>
						</div>
					);
				})}
			</div>
		);
	}

	// Tampilan Visual (kumpulan box) - dikelompokkan per UPT untuk box yang
	// sudah punya upt_id ('dialokasikan'/'aktif'); sisanya (box 'gudang'/
	// 'diterima' yang belum punya upt_id) masuk grup pool terpisah. 'habis'
	// sudah dibuang sejak fetchBoxVisual().
	renderBoxVisualBoard() {
		const { listBoxVisual, loadingBoxVisual } = this.state;
		if (loadingBoxVisual) {
			return <div style={{ textAlign: 'center', padding: 50 }}><Spin size="large" /></div>;
		}
		const perUpt = {};
		const poolByKode = {};
		listBoxVisual.forEach((b) => {
			if (b.upt) {
				if (!perUpt[b.upt]) perUpt[b.upt] = { nama: b.upt_nama, boxes: [] };
				perUpt[b.upt].boxes.push(b);
			} else {
				if (!poolByKode[b.kode_notice]) poolByKode[b.kode_notice] = { gudang: [], diterima: [] };
				poolByKode[b.kode_notice][b.status].push(b);
			}
		});
		const uptGroups = Object.values(perUpt).sort((a, b) => (a.nama || '').localeCompare(b.nama || ''));
		const poolKodes = Object.keys(poolByKode).sort();

		if (uptGroups.length === 0 && poolKodes.length === 0) {
			return <Empty description="Belum ada box notice" />;
		}
		return (
			<div>
				{uptGroups.map((group) => this._renderUptBoxGroup(group))}
				{poolKodes.length > 0 && this._renderPoolBoxSection(poolByKode, poolKodes)}
			</div>
		);
	}

	_renderUptBoxGroup(group) {
		const aktif = group.boxes.filter((b) => b.status === 'aktif');
		const cadangan = group.boxes.filter((b) => b.status === 'dialokasikan').sort((a, b) => a.nomor_box - b.nomor_box);
		return (
			<Card
				key={group.nama}
				style={{ marginBottom: 16, borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}
				title={<span><InboxOutlined style={{ marginRight: 8, color: '#1e4d8a' }} />{group.nama}</span>}
				size="small"
			>
				{aktif.length === 0 && (
					<Alert type="warning" showIcon style={{ marginBottom: 12 }} message="UPT ini belum punya box aktif" />
				)}
				<Row gutter={16}>
					{aktif.map((b) => (
						<Col key={b.id} xs={24} sm={24} md={12} lg={8}>
							<BoxVisualCard box={b} actions={this._renderBoxActions(b)} />
						</Col>
					))}
					{cadangan.map((b, i) => (
						<Col key={b.id} xs={24} sm={24} md={12} lg={8}>
							<BoxVisualCard box={b} antrian={i + 1} actions={this._renderBoxActions(b)} />
						</Col>
					))}
				</Row>
			</Card>
		);
	}

	// Pool 'gudang'/'diterima' (belum punya UPT) - sengaja dirender sebagai
	// accordion ringkas per kode_notice (bukan 1 kartu per box) supaya tetap
	// ringan walau lagi opname besar; isi box individual baru di-render saat
	// panelnya dibuka.
	_renderPoolBoxSection(poolByKode, poolKodes) {
		return (
			<Card
				style={{ borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}
				title={<span><InboxOutlined style={{ marginRight: 8, color: '#531dab' }} />Pool Kabupaten - Belum Ditempatkan</span>}
				size="small"
			>
				<Collapse>
					{poolKodes.map((kode) => {
						const { gudang, diterima } = poolByKode[kode];
						const all = [...gudang, ...diterima].sort((a, b) => a.nomor_box - b.nomor_box);
						const awalMin = Math.min(...all.map((b) => b.nomor_awal));
						const akhirMax = Math.max(...all.map((b) => b.nomor_akhir));
						return (
							<Collapse.Panel
								key={kode}
								header={
									<div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
										<Text strong style={{ fontFamily: 'monospace' }}>{kode}</Text>
										<span style={{ fontSize: 12, color: '#666' }}>
											{all.length} box · Gudang: {gudang.length} · Diterima: {diterima.length} · {String(awalMin).padStart(7, '0')}–{String(akhirMax).padStart(7, '0')}
										</span>
									</div>
								}
							>
								<Table
									size="small"
									pagination={false}
									rowKey="id"
									dataSource={all}
									columns={[
										{ title: 'No. Box', dataIndex: 'nomor_box', width: 80, align: 'center' },
										{ title: 'Rentang', key: 'rentang', render: (_, r) => `${String(r.nomor_awal).padStart(7, '0')}–${String(r.nomor_akhir).padStart(7, '0')}` },
										{ title: 'Status', dataIndex: 'status', width: 190, align: 'center', render: (v) => <StatusTag map={BOX_STATUS} value={v} /> },
										{ title: 'Kabupaten', dataIndex: 'kabupaten_nama', render: (v) => v || <Text type="secondary">—</Text> },
										{ title: 'Aksi', key: 'aksi', width: 160, align: 'center', render: (_, r) => this._renderBoxActions(r) },
									]}
								/>
							</Collapse.Panel>
						);
					})}
				</Collapse>
			</Card>
		);
	}

	_permintaanColumns() {
		const canKelola = this.canKelola();
		const cols = [
			{ title: 'UPT', dataIndex: 'upt_nama', key: 'upt_nama' },
			{ title: 'Diajukan Oleh', dataIndex: 'diajukan_oleh_nama', key: 'diajukan_oleh_nama' },
			{ title: 'Jumlah Box', dataIndex: 'jumlah_box', key: 'jumlah_box', width: 100, align: 'center' },
			{ title: 'Kode Diminta', dataIndex: 'kode_notice_diminta', key: 'kode_notice_diminta', width: 110,
				render: (v) => v || <Text type="secondary">—</Text> },
			{ title: 'Status', dataIndex: 'status', key: 'status', width: 180, align: 'center',
				render: (v) => <StatusTag map={PERMINTAAN_STATUS} value={v} /> },
			{ title: 'Jumlah Disetujui', dataIndex: 'jumlah_disetujui', key: 'jumlah_disetujui', width: 110, align: 'center' },
			{ title: 'Disetujui Oleh', dataIndex: 'disetujui_oleh_nama', key: 'disetujui_oleh_nama', render: (v) => v || <Text type="secondary">—</Text> },
		];
		if (canKelola) {
			cols.push({
				title: 'Aksi', key: 'aksi', width: 160, fixed: 'right', align: 'center',
				render: (_, row) => row.status === 'pending' ? (
					<div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
						<Tooltip title="Setujui & Alokasikan">
							<Button size="small" type="primary" style={{ background: '#389e0d', borderColor: '#389e0d' }} onClick={() => this.openApprove(row)}>
								Setujui
							</Button>
						</Tooltip>
						<Tooltip title="Tolak">
							<Button size="small" danger onClick={() => this.openReject(row)}>Tolak</Button>
						</Tooltip>
					</div>
				) : <Text type="secondary">—</Text>,
			});
		}
		return cols;
	}

	renderModalAlokasikan() {
		const {
			modalAlokasikan, loadingAlokasikan, alokasikanTargetBox, listUpt, loadingUpt,
			alokasikanUptId, konfirmasiPindahAktif, isMobile,
		} = this.state;
		if (!alokasikanTargetBox) return null;
		const boxAktif = alokasikanTargetBox.status === 'aktif';
		return (
			<Modal
				open={modalAlokasikan}
				onCancel={() => this.setState({ modalAlokasikan: false, alokasikanTargetBox: null })}
				footer={null}
				destroyOnClose
				centered
				width="min(94vw, 480px)"
				bodyStyle={{ padding: 0 }}
				className="gudangnotice-modal"
			>
				<div className="gudangnotice-modal-header">
					<div className="gudangnotice-modal-icon"><SendOutlined /></div>
					<div>
						<div className="gudangnotice-modal-title">Tempatkan / Pindahkan Box ke UPT</div>
						<div className="gudangnotice-modal-subtitle">
							Box {alokasikanTargetBox.kode_notice}-{alokasikanTargetBox.nomor_box}
						</div>
					</div>
				</div>
				<div className="gudangnotice-modal-body">
					{boxAktif && (
						<Alert
							type="warning"
							showIcon
							style={{ marginBottom: 16, borderRadius: 8 }}
							message="Box ini sedang AKTIF dipakai"
							description={
								<div>
									<div style={{ marginBottom: 8 }}>
										UPT asal langsung kehilangan box ini begitu disimpan dan tidak bisa lagi menerbitkan notice darinya (kecuali masih ada box cadangan lain). UPT tujuan otomatis lanjut menerbitkan notice dari nomor terakhir yang sudah terpakai, bukan mulai ulang.
									</div>
									<Checkbox
										checked={konfirmasiPindahAktif}
										onChange={(e) => this.setState({ konfirmasiPindahAktif: e.target.checked })}
									>
										Saya mengerti dan tetap ingin memindahkan box yang sedang aktif ini.
									</Checkbox>
								</div>
							}
						/>
					)}
					<div style={{ fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 8 }}>UPT Tujuan</div>
					<Select
						showSearch
						allowClear
						size="large"
						style={{ width: '100%', marginBottom: 24 }}
						placeholder="Cari & pilih UPT tujuan..."
						loading={loadingUpt}
						filterOption={false}
						onSearch={(v) => this.fetchUptList(v)}
						value={alokasikanUptId}
						onChange={(v) => this.setState({ alokasikanUptId: v })}
					>
						{listUpt.map((upt) => (
							<Option key={upt.id} value={upt.id}>{upt.nama}</Option>
						))}
					</Select>
					<div style={{ display: 'flex', gap: 10, flexDirection: isMobile ? 'column' : 'row', justifyContent: 'flex-end' }}>
						<Button
							size="large"
							onClick={() => this.setState({ modalAlokasikan: false, alokasikanTargetBox: null })}
							style={{ borderRadius: 8, ...(isMobile ? { width: '100%' } : {}) }}
						>
							Batal
						</Button>
						<Button
							type="primary"
							icon={<SendOutlined />}
							size="large"
							loading={loadingAlokasikan}
							disabled={boxAktif && !konfirmasiPindahAktif}
							onClick={this.handleAlokasikan}
							style={{
								borderRadius: 8,
								background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
								border: 'none',
								fontWeight: 600,
								...(isMobile ? { width: '100%' } : {}),
							}}
						>
							Simpan
						</Button>
					</div>
				</div>
			</Modal>
		);
	}

	renderModalRiwayat() {
		const { modalRiwayat, loadingRiwayat, riwayatList, riwayatBox, isMobile } = this.state;
		if (!riwayatBox) return null;
		return (
			<Modal
				open={modalRiwayat}
				onCancel={() => this.setState({ modalRiwayat: false })}
				footer={null}
				destroyOnClose
				centered
				width="min(94vw, 520px)"
				bodyStyle={{ padding: 0 }}
				className="gudangnotice-modal"
			>
				<div className="gudangnotice-modal-header">
					<div className="gudangnotice-modal-icon"><HistoryOutlined /></div>
					<div>
						<div className="gudangnotice-modal-title">Riwayat Box {riwayatBox.kode_notice}-{riwayatBox.nomor_box}</div>
						<div className="gudangnotice-modal-subtitle">Jejak perpindahan & perubahan status box ini</div>
					</div>
				</div>
				<div className="gudangnotice-modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
					{loadingRiwayat ? (
						<div style={{ textAlign: 'center', padding: 30 }}><Spin /></div>
					) : riwayatList.length === 0 ? (
						<Empty description="Belum ada riwayat perpindahan" />
					) : (
						<Timeline style={{ marginTop: 8 }}>
							{riwayatList.map((r) => (
								<Timeline.Item key={r.id}>
									<div style={{ fontSize: 13, fontWeight: 600 }}>
										{r.status_sebelum} <span style={{ color: '#999' }}>&rarr;</span> {r.status_sesudah}
									</div>
									<div style={{ fontSize: 12, color: '#666' }}>
										{r.upt_asal_nama && r.upt_asal_nama !== '-' && <>Dari: <b>{r.upt_asal_nama}</b><br /></>}
										{r.upt_tujuan_nama && r.upt_tujuan_nama !== '-' && <>Ke: <b>{r.upt_tujuan_nama}</b><br /></>}
										{r.kabupaten_tujuan_nama && r.kabupaten_tujuan_nama !== '-' && <>Ke kabupaten: <b>{r.kabupaten_tujuan_nama}</b><br /></>}
										{r.posisi_terakhir != null && <>Posisi terakhir: <b>{r.posisi_terakhir}</b><br /></>}
										{r.keterangan && <>{r.keterangan}<br /></>}
										Oleh {r.dilakukan_oleh_nama && r.dilakukan_oleh_nama !== '-' ? r.dilakukan_oleh_nama : 'sistem'} &middot; {new Date(r.created_at).toLocaleString('id-ID')}
									</div>
								</Timeline.Item>
							))}
						</Timeline>
					)}
					<div style={{ textAlign: 'right', marginTop: 16 }}>
						<Button
							size="large"
							onClick={() => this.setState({ modalRiwayat: false })}
							style={{ borderRadius: 8, ...(isMobile ? { width: '100%' } : {}) }}
						>
							Tutup
						</Button>
					</div>
				</div>
			</Modal>
		);
	}

	renderModalTambahBox() {
		const { modalTambahBox, loadingTambahBox, isMobile, cekKodeLoading, cekKodeInfo } = this.state;
		return (
			<Modal
				open={modalTambahBox}
				onCancel={() => this.setState({ modalTambahBox: false })}
				footer={null}
				destroyOnClose
				centered
				width="min(94vw, 480px)"
				bodyStyle={{ padding: 0 }}
				className="gudangnotice-modal"
			>
				<div className="gudangnotice-modal-header">
					<div className="gudangnotice-modal-icon"><PlusOutlined /></div>
					<div>
						<div className="gudangnotice-modal-title">Tambah Box Notice</div>
						<div className="gudangnotice-modal-subtitle">Daftarkan stok box baru ke gudang pusat</div>
					</div>
				</div>
				<div className="gudangnotice-modal-body">
					<Form ref={this.formTambahBoxRef} layout="vertical" onFinish={this.handleTambahBoxSubmit}>
						<Form.Item
							name="kode_notice"
							label="Kode Notice"
							rules={[{ required: true, message: 'Kode notice wajib diisi.' }]}
							normalize={(value) => (value || '').toUpperCase()}
						>
							<Input
								size="large"
								placeholder="contoh: A"
								maxLength={50}
								style={{ borderRadius: 8 }}
								onBlur={(e) => this.cekKodeNotice(e.target.value)}
							/>
						</Form.Item>
						{cekKodeLoading ? (
							<div style={{ marginTop: -12, marginBottom: 20, fontSize: 12.5, color: '#999' }}>
								<Spin size="small" style={{ marginRight: 6 }} />Memeriksa histori kode notice...
							</div>
						) : cekKodeInfo && cekKodeInfo.nomorBoxTerakhir > 0 ? (
							<Alert
								type="info"
								showIcon
								style={{ marginTop: -12, marginBottom: 20, borderRadius: 8 }}
								message={`Kode ini sudah terdaftar (box terakhir #${cekKodeInfo.nomorBoxTerakhir})`}
								description={`Saran nomor mulai box baru: ${String(cekKodeInfo.saranNomorMulai).padStart(7, '0')}${cekKodeInfo.nomorTagihanTertinggi > 0 ? ` (mempertimbangkan histori transaksi tertinggi ${String(cekKodeInfo.nomorTagihanTertinggi).padStart(7, '0')})` : ''}. Kolom di bawah bisa dikoreksi manual sesuai catatan pengadaan fisik.`}
							/>
						) : cekKodeInfo ? (
							<Alert
								type="success"
								showIcon
								style={{ marginTop: -12, marginBottom: 20, borderRadius: 8 }}
								message="Kode baru - belum pernah terdaftar sebagai box"
								description={cekKodeInfo.nomorTagihanTertinggi > 0
									? `Namun ada histori transaksi lama dengan kode ini (nomor tertinggi ${String(cekKodeInfo.nomorTagihanTertinggi).padStart(7, '0')}) - saran nomor mulai sudah melompati histori itu.`
									: 'Saran: box pertama mulai dari nomor 0000001.'}
							/>
						) : null}
						<Row gutter={12}>
							<Col span={12}>
								<Form.Item name="jumlah_box" label="Jumlah Box (1 box = 1000 lembar)" rules={[{ required: true, message: 'Jumlah box wajib diisi.' }]}>
									<InputNumber min={1} size="large" style={{ width: '100%', borderRadius: 8 }} placeholder="contoh: 100" />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									name="nomor_awal"
									label="Nomor Mulai"
									rules={[{ required: true, message: 'Nomor mulai wajib diisi.' }]}
									tooltip="Pre-fill otomatis dari saran sistem - koreksi manual sesuai catatan pengadaan fisik kalau perlu."
								>
									<InputNumber min={1} size="large" style={{ width: '100%', borderRadius: 8 }} placeholder="contoh: 1" />
								</Form.Item>
							</Col>
						</Row>
						<div style={{ marginTop: -8, marginBottom: 24, fontSize: 12, color: '#999' }}>
							Rentang final akan ditampilkan untuk dikonfirmasi sebelum benar-benar disimpan.
						</div>
						<div style={{ display: 'flex', gap: 10, flexDirection: isMobile ? 'column' : 'row', justifyContent: 'flex-end' }}>
							<Button
								size="large"
								onClick={() => this.setState({ modalTambahBox: false })}
								style={{ borderRadius: 8, ...(isMobile ? { width: '100%' } : {}) }}
							>
								Batal
							</Button>
							<Button
								type="primary"
								htmlType="submit"
								icon={<PlusOutlined />}
								size="large"
								loading={loadingTambahBox}
								style={{
									borderRadius: 8,
									background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
									border: 'none',
									fontWeight: 600,
									...(isMobile ? { width: '100%' } : {}),
								}}
							>
								Simpan
							</Button>
						</div>
					</Form>
				</div>
			</Modal>
		);
	}

	renderModalAjukan() {
		const { modalAjukan, loadingAjukan, isMobile } = this.state;
		return (
			<Modal
				open={modalAjukan}
				onCancel={() => this.setState({ modalAjukan: false })}
				footer={null}
				destroyOnClose
				centered
				width="min(94vw, 480px)"
				bodyStyle={{ padding: 0 }}
				className="gudangnotice-modal"
			>
				<div className="gudangnotice-modal-header">
					<div className="gudangnotice-modal-icon"><SendOutlined /></div>
					<div>
						<div className="gudangnotice-modal-title">Ajukan Permintaan Stok Notice</div>
						<div className="gudangnotice-modal-subtitle">Kode notice mengikuti stok yang tersedia di gudang pusat</div>
					</div>
				</div>
				<div className="gudangnotice-modal-body">
					<Form ref={this.formAjukanRef} layout="vertical" onFinish={this.handleAjukan}>
						<Form.Item name="jumlah_box" label="Jumlah Box Diminta" rules={[{ required: true, message: 'Jumlah box wajib diisi.' }]}>
							<InputNumber min={1} size="large" style={{ width: '100%', borderRadius: 8 }} placeholder="contoh: 5" />
						</Form.Item>
						<Form.Item name="keterangan" label="Keterangan (opsional)" style={{ marginBottom: 24 }}>
							<TextArea rows={3} placeholder="catatan tambahan untuk permintaan ini" style={{ borderRadius: 8 }} />
						</Form.Item>
						<div style={{ display: 'flex', gap: 10, flexDirection: isMobile ? 'column' : 'row', justifyContent: 'flex-end' }}>
							<Button
								size="large"
								onClick={() => this.setState({ modalAjukan: false })}
								style={{ borderRadius: 8, ...(isMobile ? { width: '100%' } : {}) }}
							>
								Batal
							</Button>
							<Button
								type="primary"
								htmlType="submit"
								icon={<SendOutlined />}
								size="large"
								loading={loadingAjukan}
								style={{
									borderRadius: 8,
									background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
									border: 'none',
									fontWeight: 600,
									...(isMobile ? { width: '100%' } : {}),
								}}
							>
								Ajukan
							</Button>
						</div>
					</Form>
				</div>
			</Modal>
		);
	}

	renderModalApprove() {
		const { modalApprove, loadingAction, selectedPermintaan, catatanApproval, loadingKodeTersedia, kandidatPanel, isMobile } = this.state;
		if (!selectedPermintaan) return null;

		const opsiKode = this._getOpsiKode();
		const kodeDiminta = selectedPermintaan.kode_notice_diminta;
		const target = selectedPermintaan.jumlah_box;

		return (
			<Modal
				open={modalApprove}
				onCancel={() => this.setState({ modalApprove: false })}
				footer={null}
				destroyOnClose
				centered
				width="min(94vw, 620px)"
				bodyStyle={{ padding: 0 }}
				className="gudangnotice-modal"
			>
				<div className="gudangnotice-modal-header">
					<div className="gudangnotice-modal-icon"><CheckCircleOutlined /></div>
					<div>
						<div className="gudangnotice-modal-title">Setujui & Alokasikan Stok Notice</div>
						<div className="gudangnotice-modal-subtitle">
							UPT {selectedPermintaan.upt_nama} meminta {target} box
						</div>
					</div>
				</div>
				<div className="gudangnotice-modal-body" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
				<Form ref={this.formApproveRef} layout="vertical" onFinish={this.handleApprove}
					initialValues={{ alokasi: [{ kode_notice: kodeDiminta || undefined, jumlah: 0 }] }}>
					<div style={{ marginBottom: 16, fontSize: 12.5, color: '#666', background: '#f5f8fc', border: '1px solid #e3ecf7', borderRadius: 8, padding: '10px 12px' }}>
						Kalau stok 1 kode tidak cukup, tambahkan kode notice lain untuk menutupi sisanya - jumlah box mengikuti stok yang dipilih dan tidak bisa diubah manual.
					</div>
					<Form.List name="alokasi">
						{(fields, { add, remove }) => (
							<>
								{fields.map((field) => (
									<div key={field.key} style={{ marginBottom: 8 }}>
									<Row gutter={8} align="top">
										<Col span={13}>
											<Form.Item shouldUpdate noStyle>
												{(form) => {
													const alokasiAll = form.getFieldValue('alokasi') || [];
													const kodeSendiri = alokasiAll[field.name] && alokasiAll[field.name].kode_notice;
													const kodeDipakaiBarisLain = alokasiAll
														.filter((_, idx) => idx !== field.name)
														.map((a) => a && a.kode_notice)
														.filter(Boolean);
													const opsiBaris = opsiKode.filter(
														(k) => k.kode_notice === kodeSendiri || !kodeDipakaiBarisLain.includes(k.kode_notice)
													);
													return (
														<Form.Item
															{...field}
															name={[field.name, 'kode_notice']}
															fieldKey={[field.fieldKey, 'kode_notice']}
															rules={[{ required: true, message: 'Pilih kode' }]}
															style={{ marginBottom: 0 }}
														>
															<Select
																placeholder="Kode notice"
																loading={loadingKodeTersedia}
																showSearch
																optionFilterProp="children"
																onChange={() => setTimeout(() => this.recomputeAlokasi(), 0)}
															>
																{opsiBaris.map((k) => (
																	<Option key={k.kode_notice} value={k.kode_notice} disabled={k.jumlah_box === 0}>
																		{k.kode_notice} ({k.jumlah_box} tersedia{k.jumlah_box === 0 ? ' - habis' : ''})
																	</Option>
																))}
															</Select>
														</Form.Item>
													);
												}}
											</Form.Item>
										</Col>
										<Col span={7}>
											<Form.Item
												{...field}
												name={[field.name, 'jumlah']}
												fieldKey={[field.fieldKey, 'jumlah']}
												style={{ marginBottom: 0 }}
											>
												<InputNumber disabled style={{ width: '100%' }} placeholder="0" />
											</Form.Item>
										</Col>
										<Col span={4}>
											{fields.length > 1 && (
												<Button danger type="text" icon={<CloseCircleOutlined />}
													onClick={() => { remove(field.name); setTimeout(() => this.recomputeAlokasi(), 0); }} />
											)}
										</Col>
									</Row>
									<Form.Item shouldUpdate noStyle>
										{(form) => {
											const alokasiAll = form.getFieldValue('alokasi') || [];
											const row = alokasiAll[field.name] || {};
											const kode = row.kode_notice;
											const jumlah = Number(row.jumlah) || 0;
											// Sengaja TIDAK dicek "jumlah <= 0" di sini - jumlah baris ini
											// justru DIHITUNG dari hasil centang panel (lihat
											// _syncJumlahFromKandidat). Kalau panel ikut disembunyikan saat
											// jumlah jadi 0 (semua box dikecualikan), user tidak akan pernah
											// bisa mencentang baliknya lagi.
											if (!kode) return null;
											const panel = kandidatPanel[kode];
											// Total LINTAS SEMUA baris (bukan cuma baris ini) - box yang
											// belum tercentang didisable begitu total sudah memenuhi
											// permintaan, supaya centang balik tidak bisa membuat total
											// melebihi target (lihat _syncJumlahFromKandidat - centang balik
											// menambah jumlah baris ini tanpa tahu baris lain sudah cukup).
											const totalSemua = alokasiAll.reduce((sum, a) => sum + (Number(a && a.jumlah) || 0), 0);
											const sudahCukup = totalSemua >= target;
											return (
												<div style={{ marginTop: 4, marginLeft: 4 }}>
													<Button type="link" size="small" style={{ padding: 0, height: 'auto', fontSize: 12 }}
														onClick={() => this.toggleKandidatPanel(kode, jumlah)}>
														{panel && panel.open ? 'Tutup daftar box' : 'Lihat & kecualikan box'}
														{panel && panel.excluded.length > 0 ? ` (${panel.excluded.length} dikecualikan)` : ''}
													</Button>
													{panel && panel.open && (
														<div style={{
															marginTop: 6, padding: 8, background: '#fafafa', borderRadius: 8,
															border: '1px solid #f0f0f0', maxHeight: 180, overflowY: 'auto',
														}}>
															{panel.loading ? (
																<Spin size="small" />
															) : panel.list.length === 0 ? (
																<Text type="secondary" style={{ fontSize: 12 }}>Tidak ada box gudang untuk kode ini.</Text>
															) : (
																panel.list.map((b) => {
																	const isExcluded = panel.excluded.includes(b.id);
																	const disabled = isExcluded && sudahCukup;
																	const checkbox = (
																		<Checkbox
																			checked={!isExcluded}
																			disabled={disabled}
																			onChange={() => this.toggleExcludeBox(kode, b.id)}
																		/>
																	);
																	return (
																		<div key={b.id} style={{ fontSize: 12, padding: '2px 0', display: 'flex', alignItems: 'center', gap: 6 }}>
																			{disabled ? (
																				<Tooltip title="Permintaan sudah terpenuhi - kecualikan box lain dulu kalau mau pakai box ini">
																					{checkbox}
																				</Tooltip>
																			) : checkbox}
																			<span style={{ fontFamily: 'monospace', color: disabled ? '#bfbfbf' : undefined }}>
																				box {b.nomor_box} · {String(b.nomor_awal).padStart(7, '0')}–{String(b.nomor_akhir).padStart(7, '0')}
																			</span>
																		</div>
																	);
																})
															)}
														</div>
													)}
												</div>
											);
										}}
									</Form.Item>
									</div>
								))}
								<Button type="dashed" block
									onClick={() => { add({ jumlah: 0 }); setTimeout(() => this.recomputeAlokasi(), 0); }}
									style={{ marginBottom: 16 }}>
									+ Tambah Kode Notice Lain
								</Button>
							</>
						)}
					</Form.List>
					<Form.Item shouldUpdate style={{ marginBottom: 16 }}>
						{(form) => {
							const alokasi = form.getFieldValue('alokasi') || [];
							const total = alokasi.reduce((sum, a) => sum + (Number(a && a.jumlah) || 0), 0);
							const tercukupi = total >= target;
							return (
								<div style={{ fontSize: 13, fontWeight: 600, color: tercukupi ? '#389e0d' : '#ad6800' }}>
									Total dialokasikan: {total} / {target} diminta
									{!tercukupi && (
										<span style={{ fontWeight: 400, color: '#999' }}> — kurang {target - total}, tambahkan kode lain. Tidak bisa disetujui sebelum tercukupi.</span>
									)}
								</div>
							);
						}}
					</Form.Item>
					<Form.Item label="Catatan (opsional)" style={{ marginBottom: 20 }}>
						<TextArea rows={2} value={catatanApproval} onChange={(e) => this.setState({ catatanApproval: e.target.value })} style={{ borderRadius: 8 }} />
					</Form.Item>
					<Form.Item shouldUpdate style={{ marginBottom: 0 }}>
						{(form) => {
							const alokasi = form.getFieldValue('alokasi') || [];
							const total = alokasi.reduce((sum, a) => sum + (Number(a && a.jumlah) || 0), 0);
							const tercukupi = total >= target;
							return (
								<div style={{ display: 'flex', gap: 10, flexDirection: isMobile ? 'column' : 'row', justifyContent: 'flex-end' }}>
									<Button
										size="large"
										onClick={() => this.setState({ modalApprove: false })}
										style={{ borderRadius: 8, ...(isMobile ? { width: '100%' } : {}) }}
									>
										Batal
									</Button>
									<Button
										type="primary"
										htmlType="submit"
										icon={<CheckCircleOutlined />}
										size="large"
										loading={loadingAction}
										disabled={!tercukupi}
										style={{
											borderRadius: 8,
											fontWeight: 600,
											background: tercukupi ? 'linear-gradient(135deg, #389e0d, #237804)' : undefined,
											borderColor: tercukupi ? '#237804' : undefined,
											...(isMobile ? { width: '100%' } : {}),
										}}
									>
										Setujui
									</Button>
								</div>
							);
						}}
					</Form.Item>
				</Form>
				</div>
			</Modal>
		);
	}

	renderModalReject() {
		const { modalReject, loadingAction, selectedPermintaan, catatanApproval, isMobile } = this.state;
		if (!selectedPermintaan) return null;
		return (
			<Modal
				open={modalReject}
				onCancel={() => this.setState({ modalReject: false })}
				footer={null}
				destroyOnClose
				centered
				width="min(94vw, 460px)"
				bodyStyle={{ padding: 0 }}
				className="gudangnotice-modal"
			>
				<div className="gudangnotice-modal-header">
					<div className="gudangnotice-modal-icon"><CloseCircleOutlined /></div>
					<div>
						<div className="gudangnotice-modal-title">Tolak Permintaan Stok Notice</div>
						<div className="gudangnotice-modal-subtitle">UPT {selectedPermintaan.upt_nama}</div>
					</div>
				</div>
				<div className="gudangnotice-modal-body">
					<div style={{ marginBottom: 12, fontSize: 13, color: '#666' }}>
						Permintaan ini akan ditolak dan tidak bisa diproses lagi. Tuliskan alasannya supaya UPT tahu apa yang perlu diperbaiki.
					</div>
					<TextArea
						rows={3}
						placeholder="Alasan penolakan (opsional)"
						value={catatanApproval}
						style={{ borderRadius: 8, marginBottom: 24 }}
						onChange={(e) => this.setState({ catatanApproval: e.target.value })}
					/>
					<div style={{ display: 'flex', gap: 10, flexDirection: isMobile ? 'column' : 'row', justifyContent: 'flex-end' }}>
						<Button
							size="large"
							onClick={() => this.setState({ modalReject: false })}
							style={{ borderRadius: 8, ...(isMobile ? { width: '100%' } : {}) }}
						>
							Batal
						</Button>
						<Button
							danger
							type="primary"
							icon={<CloseCircleOutlined />}
							size="large"
							loading={loadingAction}
							onClick={this.handleReject}
							style={{ borderRadius: 8, fontWeight: 600, ...(isMobile ? { width: '100%' } : {}) }}
						>
							Tolak
						</Button>
					</div>
				</div>
			</Modal>
		);
	}

	renderModalLepas() {
		const { modalLepas, loadingLepas, lepasTarget, isMobile } = this.state;
		if (!lepasTarget) return null;
		const belumDipakai = lepasTarget.status === 'aktif';
		return (
			<Modal
				open={modalLepas}
				onCancel={() => this.setState({ modalLepas: false, lepasTarget: null })}
				footer={null}
				destroyOnClose
				centered
				width="min(94vw, 460px)"
				bodyStyle={{ padding: 0 }}
				className="gudangnotice-modal"
			>
				<div className="gudangnotice-modal-header">
					<div className="gudangnotice-modal-icon"><DisconnectOutlined /></div>
					<div>
						<div className="gudangnotice-modal-title">Lepas Box dari UPT?</div>
						<div className="gudangnotice-modal-subtitle">
							Box {lepasTarget.kode_notice}-{lepasTarget.nomor_box}
						</div>
					</div>
				</div>
				<div className="gudangnotice-modal-body">
					<div style={{ marginBottom: 24, fontSize: 13, color: '#666' }}>
						{belumDipakai
							? `Box ${lepasTarget.kode_notice}-${lepasTarget.nomor_box} sedang aktif tapi belum pernah dipakai menerbitkan notice. Box ini akan dilepas dari UPT saat ini dan balik ke pool "Diterima (Belum Ditempatkan)" di kabupaten Anda - cocok kalau salah tempatkan box dan mau ditukar.`
							: `Box ${lepasTarget.kode_notice}-${lepasTarget.nomor_box} akan dilepas dari UPT saat ini dan balik ke pool "Diterima (Belum Ditempatkan)" di kabupaten Anda - siap dialokasikan ulang ke UPT lain.`}
					</div>
					<div style={{ display: 'flex', gap: 10, flexDirection: isMobile ? 'column' : 'row', justifyContent: 'flex-end' }}>
						<Button
							size="large"
							onClick={() => this.setState({ modalLepas: false, lepasTarget: null })}
							style={{ borderRadius: 8, ...(isMobile ? { width: '100%' } : {}) }}
						>
							Batal
						</Button>
						<Button
							type="primary"
							icon={<DisconnectOutlined />}
							size="large"
							loading={loadingLepas}
							onClick={this.confirmLepas}
							style={{
								borderRadius: 8,
								background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
								border: 'none',
								fontWeight: 600,
								...(isMobile ? { width: '100%' } : {}),
							}}
						>
							Ya, Lepas
						</Button>
					</div>
				</div>
			</Modal>
		);
	}

	renderModalKembalikan() {
		const { modalKembalikan, loadingKembalikan, kembalikanTarget, isMobile } = this.state;
		if (!kembalikanTarget) return null;
		return (
			<Modal
				open={modalKembalikan}
				onCancel={() => this.setState({ modalKembalikan: false, kembalikanTarget: null })}
				footer={null}
				destroyOnClose
				centered
				width="min(94vw, 460px)"
				bodyStyle={{ padding: 0 }}
				className="gudangnotice-modal"
			>
				<div className="gudangnotice-modal-header">
					<div className="gudangnotice-modal-icon"><UndoOutlined /></div>
					<div>
						<div className="gudangnotice-modal-title">Kembalikan Box ke Gudang Pusat?</div>
						<div className="gudangnotice-modal-subtitle">
							Box {kembalikanTarget.kode_notice}-{kembalikanTarget.nomor_box}
						</div>
					</div>
				</div>
				<div className="gudangnotice-modal-body">
					<div style={{ marginBottom: 24, fontSize: 13, color: '#666' }}>
						Box {kembalikanTarget.kode_notice}-{kembalikanTarget.nomor_box} akan ditarik kembali ke gudang pusat (lepas dari kabupaten/UPT saat ini, status jadi &quot;Di Gudang&quot;).
					</div>
					<div style={{ display: 'flex', gap: 10, flexDirection: isMobile ? 'column' : 'row', justifyContent: 'flex-end' }}>
						<Button
							size="large"
							onClick={() => this.setState({ modalKembalikan: false, kembalikanTarget: null })}
							style={{ borderRadius: 8, ...(isMobile ? { width: '100%' } : {}) }}
						>
							Batal
						</Button>
						<Button
							type="primary"
							icon={<UndoOutlined />}
							size="large"
							loading={loadingKembalikan}
							onClick={this.confirmKembalikan}
							style={{
								borderRadius: 8,
								background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
								border: 'none',
								fontWeight: 600,
								...(isMobile ? { width: '100%' } : {}),
							}}
						>
							Ya, Kembalikan
						</Button>
					</div>
				</div>
			</Modal>
		);
	}

	renderModalHapusBatch() {
		const { modalHapusBatch, loadingHapusBatch, selectedBoxRowKeys, listBox, isMobile } = this.state;
		if (!modalHapusBatch) return null;
		const dipilih = listBox.filter((b) => selectedBoxRowKeys.includes(b.id));
		return (
			<Modal
				open={modalHapusBatch}
				onCancel={() => this.setState({ modalHapusBatch: false })}
				footer={null}
				destroyOnClose
				centered
				width="min(94vw, 480px)"
				bodyStyle={{ padding: 0 }}
				className="gudangnotice-modal"
			>
				<div className="gudangnotice-modal-header">
					<div className="gudangnotice-modal-icon"><CloseCircleOutlined /></div>
					<div>
						<div className="gudangnotice-modal-title">Hapus {dipilih.length} Box Notice?</div>
						<div className="gudangnotice-modal-subtitle">Koreksi salah input - box status &quot;Di Gudang&quot; akan dihapus permanen</div>
					</div>
				</div>
				<div className="gudangnotice-modal-body">
					<Alert
						type="warning"
						showIcon
						style={{ marginBottom: 16, borderRadius: 8 }}
						message="Wajib pilih SELURUH box dari 1 kali penambahan sekaligus"
						description="Kalau box yang dipilih hanya sebagian dari 1 batch penambahan, sistem akan menolak - supaya tidak menyisakan rentang nomor yang bolong."
					/>
					<div style={{ maxHeight: 220, overflowY: 'auto', marginBottom: 20, border: '1px solid #f0f0f0', borderRadius: 8 }}>
						{dipilih.map((b) => (
							<div key={b.id} style={{ fontSize: 12.5, padding: '6px 12px', borderBottom: '1px solid #f5f5f5', display: 'flex', justifyContent: 'space-between' }}>
								<span style={{ fontFamily: 'monospace', fontWeight: 600 }}>{b.kode_notice} box#{b.nomor_box}</span>
								<span style={{ fontFamily: 'monospace', color: '#666' }}>{String(b.nomor_awal).padStart(7, '0')}–{String(b.nomor_akhir).padStart(7, '0')}</span>
							</div>
						))}
					</div>
					<div style={{ display: 'flex', gap: 10, flexDirection: isMobile ? 'column' : 'row', justifyContent: 'flex-end' }}>
						<Button
							size="large"
							onClick={() => this.setState({ modalHapusBatch: false })}
							style={{ borderRadius: 8, ...(isMobile ? { width: '100%' } : {}) }}
						>
							Batal
						</Button>
						<Button
							danger
							type="primary"
							icon={<CloseCircleOutlined />}
							size="large"
							loading={loadingHapusBatch}
							onClick={this.confirmHapusBatch}
							style={{ borderRadius: 8, fontWeight: 600, ...(isMobile ? { width: '100%' } : {}) }}
						>
							Ya, Hapus
						</Button>
					</div>
				</div>
			</Modal>
		);
	}

	render() {
		const {
			activeTab, isMobile, loadingBox, listBox, boxPagination, boxViewMode,
			loadingPermintaan, listPermintaan, permintaanPagination,
			stokMenipisCount, stokMenipisThreshold, stokMenipisDetails, selectedBoxRowKeys,
			filterKabupatenId, filterUptId, loadingKabupatenFilter, listKabupatenFilter,
			loadingUptFilter, listUptFilter,
		} = this.state;
		const showKabupatenFilter = this.canFilterKabupaten();
		const showUptFilter = this.canFilterUpt();

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.gudang-notice-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700; font-size: 13px; color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.gudang-notice-wrap .ant-table-tbody > tr:hover > td { background: #e8f0fb !important; }
						.gudang-notice-wrap .ant-table-tbody > tr:nth-child(even) > td { background: #fafafa; }
						.gudang-notice-wrap .ant-table-tbody > tr:nth-child(even):hover > td { background: #e8f0fb !important; }
						.gudang-aksi-btn {
							transition: transform 0.15s ease, box-shadow 0.15s ease;
						}
						.gudang-aksi-btn:not([disabled]):hover {
							transform: translateY(-2px);
							box-shadow: 0 4px 10px rgba(15, 40, 71, 0.25);
						}
						.gudang-rekap-card:hover {
							transform: translateY(-2px);
							box-shadow: 0 4px 14px rgba(0,0,0,0.1) !important;
						}

						/* ===== Modal modern (sama pola dgn modal-notice di AdminLayout.jsx) ===== */
						.gudangnotice-modal .ant-modal-content {
							border-radius: 16px;
							overflow: hidden;
						}
						.gudangnotice-modal-header {
							display: flex;
							align-items: center;
							gap: 14px;
							padding: 20px 24px 16px;
							background: linear-gradient(135deg, #0f2847, #1e4d8a);
						}
						.gudangnotice-modal-icon {
							width: 44px; height: 44px;
							border-radius: 12px;
							background: rgba(255,255,255,0.15);
							display: flex; align-items: center; justify-content: center;
							font-size: 20px; color: #fff;
							flex-shrink: 0;
						}
						.gudangnotice-modal-title { font-size: 16px; font-weight: 700; color: #fff; line-height: 1.2; }
						.gudangnotice-modal-subtitle { font-size: 12px; color: rgba(255,255,255,0.65); margin-top: 2px; }
						.gudangnotice-modal-body { padding: 24px; }
						.gudangnotice-modal .ant-form-item-label > label { font-weight: 600; color: #374151; }
						@media (max-width: 575px) {
							.gudangnotice-modal .ant-modal { margin: 0 !important; max-width: 100% !important; top: 0 !important; padding-bottom: 0 !important; }
							.gudangnotice-modal .ant-modal-content { border-radius: 0; min-height: 100vh; }
							.gudangnotice-modal-header { padding: 16px 16px 14px; }
							.gudangnotice-modal-body { padding: 16px; }
						}
					`}</style>
				</Helmet>


				<Card className="gudang-notice-wrap" style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>
					{/* Header murni identitas halaman - tombol aksi (Tambah Box/Ajukan/
						Refresh) dipindah ke dalam masing-masing tab/section supaya
						konteksnya jelas (bukan menumpuk semua tombol di 1 tempat). */}
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', gap: 10,
					}}>
						<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
							<GoldOutlined style={{ marginRight: 8 }} />
							{configClass.title}
						</div>
					</div>

					{(showKabupatenFilter || showUptFilter) && (
						<div style={{ padding: isMobile ? '14px 14px 0' : '16px 20px 0', display: 'flex', gap: 10, flexWrap: 'wrap' }}>
							{showKabupatenFilter && (
								<Select
									showSearch allowClear
									placeholder="Filter Kabupaten"
									style={{ width: isMobile ? '100%' : 220 }}
									loading={loadingKabupatenFilter}
									value={filterKabupatenId}
									filterOption={(input, option) => (option.children || '').toLowerCase().includes(input.toLowerCase())}
									onChange={this.handleFilterKabupatenChange}
								>
									{listKabupatenFilter.map((k) => <Option key={k.id} value={k.id}>{k.name}</Option>)}
								</Select>
							)}
							{showUptFilter && (
								<Select
									showSearch allowClear
									placeholder="Filter UPT"
									style={{ width: isMobile ? '100%' : 240 }}
									loading={loadingUptFilter}
									value={filterUptId}
									filterOption={(input, option) => (option.children || '').toLowerCase().includes(input.toLowerCase())}
									onChange={this.handleFilterUptChange}
								>
									{listUptFilter.map((u) => <Option key={u.id} value={u.id}>{u.nama}</Option>)}
								</Select>
							)}
						</div>
					)}

					{/* Rekap Stok - selalu tampil (bukan tab), di bawah filter & di
						atas tab Stok Box/Permintaan Stok, supaya kelihatan sekilas
						tanpa perlu pindah tab. */}
					<div style={{ padding: isMobile ? '16px 14px 0' : '18px 20px 0' }}>
						<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
							<Text strong style={{ fontSize: 14, color: '#0f2847' }}>
								<GoldOutlined style={{ marginRight: 6 }} /> Rekap Stok
							</Text>
							<Tooltip title="Refresh semua data">
								<Button size="small" icon={<RedoOutlined />}
									onClick={() => {
										this.fetchBox(); this.fetchPermintaan(); this.fetchStokMenipisCount(); this.fetchRekap();
										if (boxViewMode === 'visual') this.fetchBoxVisual();
									}}>
									{!isMobile && 'Refresh'}
								</Button>
							</Tooltip>
						</div>
						{this.renderRekapStok()}
					</div>

					<div style={{ padding: isMobile ? '16px 14px 0' : '18px 20px 0' }}>
						<Tabs activeKey={activeTab} onChange={(k) => this.setState({ activeTab: k })}>
							<TabPane tab="Stok Box" key="box">
								{stokMenipisCount > 0 && (
									<Alert
										type="warning"
										showIcon
										style={{ marginBottom: 12 }}
										message={`${stokMenipisCount} box sedang aktif dengan sisa stok ≤ ${stokMenipisThreshold} lembar`}
										description={
											<div>
												<div style={{ marginBottom: 8 }}>
													Segera ajukan/setujui permintaan tambahan supaya UPT terkait tidak berhenti menerbitkan notice di tengah pelayanan.
												</div>
												<div style={{ maxHeight: 180, overflowY: 'auto', border: '1px solid #ffe58f', borderRadius: 6, background: '#fff' }}>
													{stokMenipisDetails.map((d) => (
														<div
															key={d.box_id}
															style={{
																padding: '7px 10px', fontSize: 12.5, borderBottom: '1px solid #fff7e6',
																display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 6,
															}}
														>
															<span>
																<strong>{d.upt_nama}</strong>
																<span style={{ color: '#999' }}> ({d.kabupaten_nama})</span>
																{' - kode '}<span style={{ fontFamily: 'monospace' }}>{d.kode_notice}</span>{` box#${d.nomor_box}`}
															</span>
															<Tag color={d.sisa <= 0 ? 'red' : 'orange'} style={{ margin: 0, fontWeight: 700 }}>
																sisa {d.sisa} lembar
															</Tag>
														</div>
													))}
												</div>
											</div>
										}
									/>
								)}
								<div style={{ marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
									<div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
										{this.canKelola() && (
											<Button type="primary" size="small" icon={<PlusOutlined />}
												onClick={() => this.setState({ modalTambahBox: true, cekKodeInfo: null, lastSaranPrefilled: null })}>
												{isMobile ? 'Tambah' : 'Tambah Box'}
											</Button>
										)}
										{boxViewMode === 'table' && this.canKelola() && selectedBoxRowKeys.length > 0 && (
											<Button danger size="small" onClick={this.openHapusBatch}>
												Hapus Terpilih ({selectedBoxRowKeys.length})
											</Button>
										)}
									</div>
									<Radio.Group
										value={boxViewMode}
										buttonStyle="solid"
										size="small"
										onChange={(e) => {
											const mode = e.target.value;
											this.setState({ boxViewMode: mode });
											if (mode === 'visual' && this.state.listBoxVisual.length === 0) this.fetchBoxVisual();
										}}
									>
										<Radio.Button value="table">Tabel</Radio.Button>
										<Radio.Button value="visual">Visual</Radio.Button>
									</Radio.Group>
								</div>
								{boxViewMode === 'visual' ? this.renderBoxVisualBoard() : (
									<Table
										columns={this._boxColumns()}
										dataSource={listBox}
										loading={loadingBox}
										rowKey="id"
										scroll={{ x: 'max-content' }}
										size="middle"
										locale={{ emptyText: <Empty description="Belum ada box notice" /> }}
										rowSelection={this.canKelola() ? {
											selectedRowKeys: selectedBoxRowKeys,
											onSelect: this.handleBoxRowSelect,
											onSelectAll: this.handleBoxSelectAll,
											getCheckboxProps: (record) => ({ disabled: record.status !== 'gudang' }),
										} : undefined}
										pagination={{
											current: boxPagination.current, pageSize: boxPagination.pageSize, total: boxPagination.total,
											showSizeChanger: true, pageSizeOptions: ['10', '25', '50'],
											showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
											onChange: (page, pageSize) => this.setState(prev => ({ boxPagination: { ...prev.boxPagination, pageSize } }), () => this.fetchBox(page)),
										}}
									/>
								)}
							</TabPane>
							<TabPane tab="Permintaan Stok" key="permintaan">
								{this.canMinta() && (
									<div style={{ marginBottom: 12, display: 'flex', justifyContent: 'flex-end' }}>
										<Button type="primary" size="small" icon={<SendOutlined />}
											onClick={() => this.setState({ modalAjukan: true })}>
											{isMobile ? 'Ajukan' : 'Ajukan Permintaan'}
										</Button>
									</div>
								)}
								<Table
									columns={this._permintaanColumns()}
									dataSource={listPermintaan}
									loading={loadingPermintaan}
									rowKey="id"
									scroll={{ x: 'max-content' }}
									size="middle"
									locale={{ emptyText: <Empty description="Belum ada permintaan stok notice" /> }}
									pagination={{
										current: permintaanPagination.current, pageSize: permintaanPagination.pageSize, total: permintaanPagination.total,
										showSizeChanger: true, pageSizeOptions: ['10', '25', '50'],
										showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
										onChange: (page, pageSize) => this.setState(prev => ({ permintaanPagination: { ...prev.permintaanPagination, pageSize } }), () => this.fetchPermintaan(page)),
									}}
								/>
							</TabPane>
						</Tabs>
					</div>
				</Card>

				{this.renderModalAlokasikan()}
				{this.renderModalRiwayat()}
				{this.renderModalTambahBox()}
				{this.renderModalAjukan()}
				{this.renderModalApprove()}
				{this.renderModalReject()}
				{this.renderModalLepas()}
				{this.renderModalKembalikan()}
				{this.renderModalHapusBatch()}

				<ErrorAlertModal
					visible={this.state.errMsg !== ''}
					title={this.state.errTitle}
					error={this.state.errMsg}
					onClose={() => this.setState({ errMsg: '', errTitle: '' })}
					// Modal lain di halaman ini (mis. modalAlokasikan) sering masih
					// terbuka saat error muncul - default zIndex Modal antd (1000)
					// sama utk semua, jadi pop up error perlu zIndex lebih tinggi
					// supaya pasti tampil di depan, bukan ketutup di belakang.
					zIndex={1010}
				/>
			</div>
		);
	}
}

const mapStateToProps = function (state) {
	return state.configReducers;
};

export default connect(
	mapStateToProps,
	{ initHandler, setConfig, ajaxViewHandler, ajaxHandler }
)(DataGudangNotice);
